<template>
  <div class="item-text-stats">
    <skeleton-loader width="45px" height="29px" class="mb-2" v-if="loading"/>
    <h2 class="value" v-else>{{ value }}</h2>

    <skeleton-loader width="156px" height="17px" v-if="loading"/>
    <p class="name" v-else>{{ name }}</p>
  </div>
</template>

<script>
import SkeletonLoader from '@/support/components/loader/SkeletonLoader.vue';

export default {
  name: 'ItemTextStats',

  props: {
    name: {
      required: true,
      type: String,
    },
    value: {
      required: true,
      type: [String, Number],
    },
    loading: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  components: {
    SkeletonLoader,
  },
};
</script>

<style lang="scss" scoped>
.item-text-stats {
  @apply flex;
  @apply flex-1;
  @apply flex-col;

  > .value {
    font-weight: 500;
    @apply text-secondary-900;
    @apply text-2xl;
  }

  > .name {

  }
}
</style>
